module.exports = __webpack_public_path__ + "img/program-radio.d9559cf4.jpg";